'user strict'
const { nextTick } = require('process')
const ex = require('../lib/error')
const expenses = require('../models').expenses
const sequelize = require('sequelize')
const Op = sequelize.Op
const moment = require('moment')
const excel = require('exceljs')

const getAllExpenses = (req, res, next) => {
    const where = { 
      userid: req.params.userid,
      is_active: true
    }
    
    expenses
      .findAndCountAll({
        where: where, order: [['expenseDate', 'DESC']]})
      .then(expenseList => {
        req.responseObject.messageCode = 'OVA005'
        req.responseObject.data = expenseList
        next()
      })
      .catch(error => {
        let errCode
        errCode = 'OVA006'
        ex.raiseError(req, res, errCode, 500, error)
      })
}
const addExpense =(req, res, next) => {
    expenses
    .create(req.body)
    .then(expenses => {
      req.responseObject.messageCode = 'MAUD001'
      req.responseObject.data = expenses
      next()
    })
    .catch(error => {
      let errCode
      if (error.name === 'SequelizeUniqueConstraintError') {
        errCode = 'MAUD003'
      } else {
        errCode = 'MAUD004'
      }
      ex.raiseError(req, res, errCode, 500, error)
    })
}

const updateExpense = (req, res, next) => {
  expenses
  .update(req.body, {
    where: { id: req.params.id },
    returning: true
  })
  .then(expense => {
    req.responseObject.data =  expense
    next()
  })
  .catch(error => {
    ex.raiseError(req, res, 'OVA008', 500, error)
  })
}

const deleteExpense = (req, res, next) => {
  expenses
  .update({is_active: false}, {
    where: { id: req.params.id },
    returning: true
  })
  .then(expense => {
    req.responseObject.data =  expense
    next()
  })
  .catch(error => {
    ex.raiseError(req, res, 'OVA008', 500, error)
  })
}

const getExpensesWithDate = (req, res, next) => {
  const where ={userid:req.params.userid,
    is_active: true,
    expenseDate: {
      [Op.gte]: req.body.startDate,
      [Op.lte]: req.body.endDate
   }}
  expenses
    .findAll({
      where: where, order: [['expenseDate', 'DESC']]})
    .then(expenseList => {
      req.responseObject.messageCode = 'OVA005'
      req.responseObject.data.expenseList = expenseList
      next()
    })
    .catch(error => {
      let errCode
      errCode = 'OVA006'
      ex.raiseError(req, res, errCode, 500, error)
    })
}
const addExpenseInBulk =  (req, res, next) => {
  expenses.bulkCreate(req.body, { returning: true })
  .then(items => {
    req.responseObject.data = items
    next()
  })
  .catch(error => {
    let errCode
    errCode = 'MAUD006'
    ex.raiseError(req, res, errCode, 500, error)
  });
}

const exportExpenses =  (req, res, next) => {
  expenses
  .findAll({where: {
    createdAt: {
      [Op.between]: [moment().subtract(req.params.noMonth, 'months').startOf('months'),
      moment().subtract(req.params.noMonth, 'months').endOf('months')]
    }}})
  .then(expenseData => {
    req.responseObject.messageCode = 'MAUD005'
    req.responseObject.data = expenseData
    next()
  })
  .catch(error => {
    let errCode
    errCode = 'MAUD006'
    ex.raiseError(req, res, errCode, 500, error)
  })
}

const generateExpenseXls =  (req, res, next) => {
  const workbook = new excel.Workbook();
  const users = workbook.addWorksheet('users');
  const A = 'A'
  const B = 'B'
  const C = 'C'
  const D = 'D'
  const E = 'E'
  const F = 'F'
  const G = 'G'
  const H = 'H'
  const I = 'I'
  const J = 'J'
  const K = 'K'

  let rowNo = 1
  users.getCell(A + rowNo).value = "expenseId "
  users.getCell(B + rowNo).value = "ExpenseName"
  users.getCell(C + rowNo).value = "Date"
  users.getCell(D + rowNo).value = "Amount"
  users.getCell(E + rowNo).value = "userid"
  users.getCell(F + rowNo).value = "ModifiedDate"

  rowNo++;
  req.responseObject.data.forEach((exp, position) => {
    users.getCell(A + rowNo).value = exp.id
    users.getCell(B + rowNo).value = exp.name
    users.getCell(C + rowNo).value = exp.expenseDate
    users.getCell(D + rowNo).value = exp.amount
    users.getCell(E + rowNo).value = exp.userid
    users.getCell(F + rowNo).value = exp.updatedAt
    rowNo++
  });


  const fileName = "expenses_" + new Date().getTime() + ".xls"
  workbook.xlsx.writeFile(__dirname+'/../../public/expenses/'+fileName)
  req.responseObject.data = "http://" + (req.headers.host ? req.headers.host : req.connection.remoteAddress) + "/expenses/" +fileName

  next()

}




module.exports = {
    getAllExpenses,
    addExpense,
    addExpenseInBulk,
    updateExpense,
    getExpensesWithDate,
    exportExpenses,
    generateExpenseXls,
    deleteExpense
}